import PropTypes from 'prop-types'

/**
 * @typedef {Object} ElectricUserSettings
 *
 * @property {string} [energyEfficiencyUnit] - The user energy efficiency unit
 */
export const electricUserSettingsPropType = PropTypes.shape({
    energyEfficiencyUnit: PropTypes.string
})
